import React from 'react';
import { Box, Fab, Tooltip, Portal } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { alpha } from '@mui/material/styles';

interface AssistantLauncherProps {
  onClick: () => void;
  hidden?: boolean;
}

export const AssistantLauncher: React.FC<AssistantLauncherProps> = ({ onClick, hidden }) => (
  <Portal>
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 24, md: 32 },
        right: { xs: 20, md: 32 },
        left: 'auto',
        zIndex: (theme) => (theme.zIndex?.tooltip || 1500) + 200,
        display: hidden ? 'none' : 'block',
        'body.map-fullscreen &': {
          display: 'none',
        },
      }}
    >
      <Tooltip title="Need changes? Ask TripGen AI" placement="left" arrow>
        <Fab
          color="primary"
          onClick={onClick}
          sx={(theme) => ({
            width: { xs: 48, md: 64 },
            height: { xs: 48, md: 64 },
            boxShadow: `0 18px 28px ${alpha(theme.palette.primary.main, 0.3)}`,
          })}
        >
          <ChatBubbleOutlineRoundedIcon sx={{ fontSize: { xs: 24, md: 30 } }} />
        </Fab>
      </Tooltip>
    </Box>
  </Portal>
);
